import classNames from "classnames";
import { IconButton } from "components";
import { FC, ReactNode } from "react";
export interface ModalBaseProps {
  open: boolean;
  onClose: () => void;
}

interface props extends ModalBaseProps {
  title?: string;
  disableGutters?: boolean;
  children: ReactNode;
}

export const Modal: FC<props> = (props) => {
  return (
    <dialog
      className="modal modal-bottom bg-[#333333CC]"
      open={props.open}
      onClose={props.onClose}
    >
      <div className="overflow-hidden modal-box max-w-md md:mx-auto p-3 bg-transparent shadow-none">
        <div className="relative bg-white rounded-2xl overflow-hidden">
          <div className="absolute top-0 inset-x-0">
            <div className="flex items-center h-[58px] px-4">
              <div className="flex-1 font-bold text-gray-400">
                {props.title}
              </div>
              <IconButton
                size="xs"
                color="solid"
                iconName="XMark"
                buttonProps={{ onClick: props.onClose }}
              />
            </div>
          </div>
          <div
            className={classNames(
              "mt-[58px] overflow-y-auto max-h-[calc(100vh_-_160px)]",
              { "px-3": !props.disableGutters }
            )}
          >
            {props.children}
          </div>
        </div>
      </div>
    </dialog>
  );
};
